import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";

type FlagBag = {
  enableOrgDesign?: boolean | null;
  enableDemoODOptions?: boolean | null;
  enableDesignOptions?: boolean | null;
};

/** Named design options — enableOrgDesign AND enableDemoODOptions AND enableDesignOptions. */
export const isDesignOptionsEnabled = ({
  enableOrgDesign,
  enableDemoODOptions,
  enableDesignOptions,
}: FlagBag): boolean =>
  Boolean(enableOrgDesign && enableDemoODOptions && enableDesignOptions);

export const useDesignOptionsEnabled = (): boolean => {
  const flags = useWorkspaceFeatureFlags() ?? {};
  return isDesignOptionsEnabled(flags);
};
